module.exports = __webpack_public_path__ + "img/action-launch.ee209377.svg";